import { observer } from "mobx-react";
import { Link } from "react-router-dom";
import { zeroPad } from "../../utils/functions";
interface IOrderSuccessBanner {
  orderId: number;
  handleOrderSuccessClose: () => void;
  successMessage: string;
  isTableOrder: boolean;
}

const OrderSuccessBanner = observer(
  ({
    orderId,
    handleOrderSuccessClose,
    successMessage,
    isTableOrder,
  }: IOrderSuccessBanner) => {
    return (
      <>
        <div className="m-3 p-3 text-center">
          <h6 className="text-success">
            {successMessage ?? "Order placed successfully!"}
          </h6>
          <div className="badge p-3 bg-default">
            Order # {zeroPad(orderId, 8)}
          </div>
          <p className="">
            <Link
              to={`${isTableOrder ? "orders" : "my-orders"}?id=${orderId}`}
              className="text-decoration-none me-2"
              onClick={handleOrderSuccessClose}
            >
              Click here
            </Link>
            to check your order status
          </p>
        </div>
        <div className="text-center mb-2">
          <button
            className="btn btn-secondary"
            type="button"
            onClick={handleOrderSuccessClose}
          >
            Close
          </button>
        </div>
      </>
    );
  }
);

export default OrderSuccessBanner;
